module.exports = __webpack_public_path__ + "img/forgotten.b67553cc.png";